import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, parseISO } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  if (typeof date === 'string') {
    return format(parseISO(date), 'MMM d, yyyy');
  }
  return format(date, 'MMM d, yyyy');
}

export function formatTime(date: string | Date): string {
  if (typeof date === 'string') {
    return format(parseISO(date), 'h:mm a');
  }
  return format(date, 'h:mm a');
}

export function formatDateTime(date: string | Date): string {
  if (typeof date === 'string') {
    return format(parseISO(date), 'MMM d, yyyy h:mm a');
  }
  return format(date, 'MMM d, yyyy h:mm a');
}

export function formatRelativeTime(date: string | Date): string {
  if (typeof date === 'string') {
    date = parseISO(date);
  }
  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);
  
  if (diffInHours < 1) {
    const minutes = Math.floor(diffInHours * 60);
    return minutes < 1 ? 'Just now' : `${minutes}m ago`;
  }
  if (diffInHours < 24) {
    return `${Math.floor(diffInHours)}h ago`;
  }
  if (diffInHours < 48) {
    return 'Yesterday';
  }
  return format(date, 'MMM d');
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    new: 'bg-blue-100 text-blue-800',
    contacted: 'bg-yellow-100 text-yellow-800',
    responded: 'bg-purple-100 text-purple-800',
    scheduled: 'bg-green-100 text-green-800',
    hired: 'bg-emerald-100 text-emerald-800',
    rejected: 'bg-red-100 text-red-800',
    opted_out: 'bg-gray-100 text-gray-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export function getStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    new: 'New',
    contacted: 'Contacted',
    responded: 'Responded',
    scheduled: 'Scheduled',
    hired: 'Hired',
    rejected: 'Rejected',
    opted_out: 'Opted Out',
  };
  return labels[status] || status;
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}
